<template>
	<div class="page">
		<!-- <van-nav-bar title="详情" :left-arrow="canBack" @click-left="onClickLeft" /> -->
		<div class="prview-content">
			<div class="title">{{notify.title}}</div>
			<div class="content" v-html="notify.content"></div>
		</div>
	</div>
</template>

<style scoped="scoped">
</style>
<script>
	import {
		getDetailByCode
	} from '@/api/news.js'

	export default {
		name: 'NewsPublic',
		components: {},
		data() {
			return {
				notify: {},
				canBack: false,
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			}
		},
		mounted() {
		},
		created() {
			const code = this.$route.query.code;
			this.canBack = !!this.$route.query.canBack
			getDetailByCode(code).then((rep) => {
				this.notify = rep.data;
			})
		}
	}
</script>
